var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"parent",staticClass:"awdb",class:_vm.awardLevel,attrs:{"data-active":"false"}},[_c('Icon',{attrs:{"name":`award-${_vm.type}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }